module.exports = {"title":"IT找活网","meta":{"title":"IT找活网：工程师的「时间变现神器」，兼职接单、找活、副业、找人帮忙，一站搞定！","description":"IT找活网覆盖IT、电子及企业服务领域的兼职副业平台，助技术人才找活接单、技能变现。涵盖IT类（软件开发含嵌入式/游戏/APP、运维、测试、系统集成、AI开发、大模型部署微调等）、电子类（电子电器/PCB设计、单片机/ARM/FPGA开发等）、设计创意类（3D建模、影视后期、UI/平面设计等）及企业服务类（文档代写、资质代办、财务托管等）海量任务，支持技术外包、短期劳务、远程兼职。需找人解决技术或事务难题？一键发布需求，专业人才快速响应，精准匹配服务，让碎片时间变收益，高效搞定各类需求。","keywords":"IT工程师兼职,技术外包服务,电子工程师找活,软件开发兼职,APP开发外包,嵌入式开发接单,服务器运维服务,PCB设计外包,UI设计兼职,3D建模服务,技术方案代写,单片机开发服务,网络安全运维,AI大模型开发,远程技术接单,电子电器设计,平面设计兼职,系统集成调试,专利申请代办,游戏开发副业,存储设备调试,产品外观设计,弱电集成服务,财务代记账,副业技术变现","webSite":"https://www.itgetjob.com/"}}


//////////////////
// WEBPACK FOOTER
// ./conf.json
// module id = wrCz
// module chunks = 86